import { ApiListResponse } from '@oncolens/oncolens-ui/lib/dto/api/ApiResponse';
import { useQuery } from 'react-query';
import api from '@/utils/httpClient';
import { DiseaseDto } from '@/features/requests/components/NewRequest/Templates/osu/dtos/Disease';

export const getRequestDiseases = (requestId: string) => {
  return api
    .get(`/api/diseases/${requestId}/diseases`)
    .then((response) => (response.data as ApiListResponse<DiseaseDto>).data);
};

export const useRequestDiseases = (requestId: string) => {
  return useQuery(['requestdiseases', requestId], () => getRequestDiseases(requestId));
};
